

































































































































import Component from 'vue-class-component'
import Accordion from '@/components/Accordion.vue'
import { getModule } from 'vuex-module-decorators'
import { StatementModule } from '@/store/modules/statement.module'
import {
  ETemplateLevel,
  ETemplateType,
  ICollectionTask,
  IStatement,
  ITemplate,
  IUser
} from '@zunta/configurations'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import CollectionSharedFunctions from '../../CollectionSharedFunctions'
import Vue2Filters from 'vue2-filters'
import FileInput from '@/components/inputs/FileInput.vue'
import Input from '@/components/inputs/Input.vue'
import TextArea from '@/components/inputs/TextArea.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'

const uniqBy = require('lodash.uniqby')

@Component({
  mixins: [Vue2Filters.mixin],
  components: {
    LoaderWrapper,
    TextArea,
    Input,
    FileInput,
    Accordion,
    DateTimeLabel
  },
  props: {
    newTask: {
      required: true
    }
  }
})
export default class CollectionActionMail extends CollectionSharedFunctions {
  statementModuleInstance: StatementModule = getModule(StatementModule, this.$store)
  isLoading: boolean = false
  isLoadingFile: boolean = false
  assignedTo: number | undefined = (this.$props.newTask as ICollectionTask).assignedUser as number
  templateTitle: string = ''
  templateMessage: string = ''
  fileName: string = ''
  templateName: string = ''

  get validated () {
    return this.fileName
  }

  get templateList () {
    return this.$store.state.template.templates.filter((template: ITemplate) => (
        template.type === ETemplateType.LETTER
    ))
  }

  get statementList () {
    return uniqBy(this.$store.state.statement.statementList, (statement: IStatement) => {
      return new Date(statement.createdAt).toLocaleDateString() + '-' + statement.remaining
    })
  }

  get facilityId () {
    return this.selectedResident ? this.selectedResident.facility : null
  }

  rememberLocation () {
    this.$locationManager.rememberLocation(this.$route.fullPath)
  }

  async selectPDFLetterToUpload (item: any): Promise<any> {
    if (!item) {
      this.fileName = ''
      this.templateName = ''
      // @ts-ignore
      this.$refs['statementFile'].clear()
      return
    }

    try {
      this.isLoadingFile = true
      const res = await this.templateModuleInstance.uploadPDFLetter(item)
      if (typeof res === 'string') {
        const regex = /pdf-letters\/(.*)/gm
        this.fileName = res.replace(regex, '$1')
        this.templateName = item.name
      }
    } catch (e) {
      console.error(e)
    } finally {
      this.isLoadingFile = false
    }
  }

  async generateTemplateAndGoReview () {
    if (!this.validated) {
      return
    }
    const templatePayload = {
      templateName: this.templateName,
      type: ETemplateType.LETTER_PDF,
      level: ETemplateLevel.STATEMENT,
      fileName: this.fileName,
      title: this.templateTitle,
      body: `<p>${this.templateMessage}</p>`
    }
    const template = await this.templateModuleInstance.addTemplate(templatePayload)
    this.$locationManager.rememberAndGoTo(this.goToTemplate(template))
  }

  goToTemplate (template: ITemplate) {
    return {
      name: 'collection-mail-review',
      params: {
        type: 'template',
        id: template.id.toString(),
        assignedTo: this.assignedTo,
        residentId: this.residentId.toString()
      }
    }
  }

  goToStatement (statement: IStatement) {
    return {
      name: 'collection-mail-review',
      params: {
        type: 'statement',
        id: statement.id.toString(),
        assignedTo: this.assignedTo,
        residentId: this.residentId.toString()
      }
    }
  }

  async mounted () {
    await this.fetchData()
  }

  async fetchData () {
    try {
      this.isLoading = true
      await this.templateModuleInstance.fetchTemplates({})
      await this.statementModuleInstance.getResidentStatementListByFilters({
        filters: {},
        residentId: this.residentId
      })
    } finally {
      this.isLoading = false
    }
  }
}
